import { render, staticRenderFns } from "./landDongInfo.vue?vue&type=template&id=4e1002ce&scoped=true"
import script from "./landDongInfo.vue?vue&type=script&lang=js"
export * from "./landDongInfo.vue?vue&type=script&lang=js"
import style0 from "./landDongInfo.vue?vue&type=style&index=0&id=4e1002ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1002ce",
  null
  
)

export default component.exports